import React from 'react';
import { RefinementList } from 'react-instantsearch';
import sortBy from 'lodash.sortby';

import FilterBlock from '../../elements/FilterBlock';
import formatContentTypeLabel from '../../../helpers/formatContentTypeLabel';
import { useScreenMinLg } from '@hooks/useResponsive';

const transformItems = items =>
    sortBy(
        items
            .filter(item => item.label !== 'publication')
            .map(item => ({ ...item, label: formatContentTypeLabel(item.label) })),
        ['label']
    );

const EverythingFilters = () => {
    const isScreenMinLg = useScreenMinLg();

    return (
        <FilterBlock label="Content Type" defaultExpanded={isScreenMinLg}>
            <RefinementList attribute="content_type" limit={99999} transformItems={transformItems} />
        </FilterBlock>
    );
};

export default EverythingFilters;
